import { defineMessages } from 'react-intl';

const messages = defineMessages({
  propertyGenericMessage: {
    id: 'App.NaurWarning.PropertyGenericMessage',
    defaultMessage:
      'There is at least one building at this property ' +
      'that is currently non-compliant with the Next Available Unit Rule (NAUR), ' +
      'which may impact your leasing activity. Visit the Unit Compliance screen for details.',
  },
  naurWarningMessage: {
    id: 'App.NaurWarning.NaurWarningMessage',
    defaultMessage:
      'This unit is located in a building that is currently non-compliant with the Next Available Unit Rule (NAUR). ' +
      'Leasing activity for this unit may be impacted until the NAUR requirement is satisfied. ' +
      'Visit the Unit Compliance screen for details.',
  },
  naurTriggeredMessage: {
    id: 'App.NaurWarning.NaurTriggeredMessage',
    defaultMessage:
      'This unit has triggered a Next Available Unit Rule (NAUR) requirement and must be satisfied. ' +
      'Visit the Unit Compliance screen for details.',
  },
  naurFloorPlanMessage: {
    id: 'App.NaurWarning.NaurFloorPlanMessage',
    defaultMessage:
      'There is an open or pending NAUR event for this unit. ' +
      'You cannot make changes to this floor plan until the NAUR event is satisfied.',
  },
});

export default messages;
